<div class="flex h-full flex-col">
  <div class="header relative p-3">
    <div class="title text-center text-lg">Happy Pay Withdrawal</div>
    <button
      type="button"
      class="close absolute top-[50%] right-3 -translate-y-[50%]"
      (click)="dismissModal()">
      <fa-icon [icon]="faTimes"></fa-icon>
    </button>
  </div>
  <form
    class="flex-1 space-y-3 overflow-y-auto p-3"
    [formGroup]="withdrawalForm"
    (ngSubmit)="onSubmit()">
    <div class="form-control relative">
      <input
        #amount
        type="number"
        formControlName="amount"
        min="0"
        class="w-full rounded-md border border-primary-main p-2 placeholder:text-primary-main focus:border-primary-main focus:outline-none focus:ring-1 focus:ring-primary-main"
        placeholder="Amount"
        id="amount" />
      <label
        for="amount"
        *ngIf="amount.value"
        class="absolute left-2 -top-2 w-fit bg-white px-1 text-xs text-primary-md-dark opacity-100">
        {{ amount.placeholder }}
      </label>
    </div>
    <div class="form-control-dropdown relative">
      <div
        class="relative w-full rounded-md bg-white text-primary-darkest outline-none">
        <p-dropdown
          class="w-full"
          styleClass="w-full border-primary-dark"
          [options]="bankAccountDropdown"
          optionValue="value"
          formControlName="to_bank_account_id"
          appendTo="body"
          optionLabel="label"></p-dropdown>
      </div>
      <label
        for="to_bank_account_id"
        class="absolute left-2 -top-2 w-fit bg-white px-1 text-xs text-primary-md-dark opacity-100">
        to Bank Account
      </label>
    </div>
  </form>
  <div class="action-btn flex items-center justify-end gap-3 p-3">
    <button
      type="button"
      class="py-1 px-3 text-primary-darkest duration-300 ease-in-out hover:-translate-y-1"
      (click)="dismissModal()">
      Cancel
    </button>
    <button
      type="submit"
      class="rounded-md bg-primary-darkest px-3 py-1 text-white duration-300 ease-in-out hover:-translate-y-1"
      [disabled]="loading"
      [ngClass]="{ 'opacity-50': loading }"
      (click)="onSubmit()">
      <span class="btn-label">Withdraw</span>
      <fa-icon
        class="load-icon"
        *ngIf="loading"
        [icon]="faSpinner"
        [spin]="true"></fa-icon>
    </button>
  </div>
</div>
